export enum EConnectionCheckStatus {
  CONNECTED = "CONNECTED",
  PENDING = "PENDING",
  ERROR = "ERROR",
  UNKNOWN = "UNKNOWN",
}
